import { Component, inject, Injectable, Injector, OnInit, Type } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IModalComponent } from "./Types/IModalComponent";

export interface DirectModalLinkComponentData {
  modal: Type<IModalComponent>
}

@Injectable()
export class DirectModalLinkService {
  // If user goes to a standalone modal, then pastes in the URL of another standalone modal in the same browser window,
  // the page won't "refresh"; instead Angular will handle this navigation by updating the paramMap, which will result
  // in the new modal trying to open, but the old one trying to close and navigate to the home page, which results in
  // a "Unsaved Changes" modal displaying.
  public ModalDisplayCount: number = 0;
}

@Component({
  selector: 'direct-modal-link',
  template: '<!-- Direct modal link -->',
  standalone: true,
  providers: [DirectModalLinkService]
})
export class DirectModalLinkComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private injector = inject(Injector);
  private router = inject(Router)
  private directModalLinkService = inject(DirectModalLinkService);

  ngOnInit() {
    this.route.data.subscribe((data : DirectModalLinkComponentData) => {
      if (!data || !data.modal) this.returnToHomepage();

      this.route.paramMap.subscribe((params) => {
        this.directModalLinkService.ModalDisplayCount++;

        this.getModal(data.modal).ShowStandaloneModal(data, params).subscribe(() => {
          this.directModalLinkService.ModalDisplayCount--;

          if (this.directModalLinkService.ModalDisplayCount <= 0) {
            this.directModalLinkService.ModalDisplayCount = 0;
            this.returnToHomepage();
          }
        });
      });
    });
  }

  private getModal(componentClass: Type<IModalComponent>) {
    return this.injector.get(componentClass, null);
  }

  private returnToHomepage() {
    this.router.navigate(["/"]);
  }
}
